module.exports = __webpack_public_path__ + "static/img/mrlymk.beaf976.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/mrlymk.png
// module id = bVWk
// module chunks = 0